import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import UserCreate from 'components/User/Create';

const ScreenUserCreate = ({ classes, match }) => (
  <div className={classes.container}>
    <GridContainer justify="center">
      <GridItem xs={12} sm={8} md={8}>
        <GridItem>
          <UserCreate
            fromAgency={match.params.userType === 'userAgency'}
            agencyId={match.params.agencyId}
          />
        </GridItem>
      </GridItem>
    </GridContainer>
  </div>
);

ScreenUserCreate.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(validationFormsStyle)(ScreenUserCreate);
